if (!customElements.get('product-sticky')) {
  class ProductSticky extends HTMLElement {
    constructor() {
      super();

      this.handleScrollRef = this.handleScroll.bind(this);
    }

    getTarget() {
      const root = document.querySelector('product-selector');
      if (!root) return null;

      return (
        root.querySelector('.product-selector__actions') ||
        root.querySelector('.product-selector__grid') ||
        root
      );
    }

    handleScroll() {
      if (window.scrollY <= 50) {
        this.classList.remove('is-visible');
        return;
      }

      const target = this.getTarget();
      if (!target) {
        this.classList.remove('is-visible');
        return;
      }

      this.classList.toggle(
        'is-visible',
        target.getBoundingClientRect().top <= 140,
      );
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScrollRef);
    }

    connectedCallback() {
      if (!this.getTarget()) return;

      window.addEventListener('scroll', this.handleScrollRef, {
        passive: true,
      });

      this.handleScroll();
    }
  }

  customElements.define('product-sticky', ProductSticky);
}
